document.addEventListener('click', function (event) {
    const target = event.target as HTMLElement;
    if (
        target.classList.contains('ad-popup__close') ||
        target.classList.contains('ad-popup__close-icon')
    ) {
        target.closest('.ad-popup--desktop, .ad-popup--mobile')?.classList.add('invisible');
    }
});
